<template>
    <div class="collectMedalBox">
        <van-loading
            v-if="loading"
            type="spinner"
            color="#E41D1D"
            class="loadIcon"
        />
        <van-pull-refresh v-else v-model="isLoading" @refresh="onRefresh">
            <div>
                <div class="header">
                    <img v-if="memberMedalExtend.topImage" :src="memberMedalExtend.topImage" alt="" @click="viewThreeModel" class="medalImg" />
                    <img v-if="memberMedalExtend.backMusic" :src="isPlay ? OpenMusicImg : CloseMusicImg" alt="" @click="playMusic" class="playImg" />
                </div>
                <div class="title pd_15">
                    <img v-if="memberMedalExtend.titleType == 1" :src="memberMedalExtend.title" alt="" />
                    <div v-else :style="`fontSize:${Number(memberMedalExtend.titleSize)}px;color:${memberMedalExtend.titleColour}`">{{memberMedalExtend.title}}</div>
                </div>
                <div class="logoBox pd_15">
                    <div class="left">
                        <img :src="LogoImg" alt="" />
                        <p>中国军号客户端</p>
                    </div>
                    <div class="right">限量 {{ medalDetail.count }} 份</div>
                </div>
                <div class="descBox pd_15">
                    <div class="desc">
                        <span class="line bg1"></span>
                        <span class="name">徽章故事</span>
                        <span class="line bg2"></span>
                    </div>
                    <div class="descImg">
                        <img :src="memberMedalExtend.medalDesc" alt="" />
                    </div>
                </div>
                <div :class="['btnBox', 'pd_15', isShowBtn && 'show']">
                    <van-button
                        :color="memberMedalExtend.themeColor || 'linear-gradient(180deg, #E41D1D 0%, #FF3737 100%)'"
                        block
                        :loading="btnLoading"
                        loading-text="领取中..."
                        @click="handleCollect"
                    >{{ btnName }}</van-button>
                </div>
            </div>
        </van-pull-refresh>
        <!-- 海报分享元素 默认隐藏 -->
        <div class="posterImgWrap">
            <div id="posterImgBox" class="posterImgBox">
                <div class="userBox">
                    <div class="userImg">
                        <!-- <img :src="'https://image-pre.junhao.mil.cn/spider/pic/upload/image/2022/02/16/05831c40adf84d68acc91b5224654774.png' || userInfo.avatar || AvatarImg" alt="" /> -->
                        <img :src="userInfo.avatar || AvatarImg" alt="" />
                    </div>
                    <p class="userName pd_15">{{ userInfo.nickname }}</p>
                    <div class="medalImg">
                        <img :src="medalDetail.medalIcon" alt="" />
                    </div>
                    <p class="num">No.{{ userCollectNum }}</p>
                </div>
                <div class="tipBox pd_15">
                    <p class="tip">我领取了No.{{ userCollectNum }}</p>
                    <p class="tip">{{medalDetail.medalName}}</p>
                </div>
                <div class="logoWrap pd_15">
                    <div class="left">
                        <div class="top">
                            <img class="logoImg" :src="LogoImg" alt="" />
                            <img class="tipImg" :src="TipImg" alt="" />
                        </div>
                        <p class="bottom">长按识别二维码领取{{medalDetail.medalName}}</p>
                    </div>
                    <div class="right">
                        <img :src="memberMedalExtend.prep1" alt="" />
                    </div>
                </div>
            </div>
        </div>
        
        <!-- 领取成功提示框 -->
        <van-overlay :show="showTip" lock-scroll class-name="tipWrapper">
            <div class="box" @click.stop>
                <div class="imgBox">
                    <img :src="medalDetail.medalIcon" alt="" />
                    <p class="num">No.{{ userCollectNum }}</p>
                </div>
                <div class="tip">恭喜你！成功领取{{medalDetail.medalName}}</div>
                <div class="footer">
                    <div class="closeBtn leftBtn" @click="closeOverlay">知道了</div>
                    <div class="closeBtn rightBtn" @click="() => closeOverlay('share')">去分享</div>
                </div>
            </div>
        </van-overlay>

        <!-- 弹层打开图片  背景透明 -->
        <van-popup
            v-model="showShare"
            :lazy-render="false"
            :close-on-click-overlay="false"
            close-icon-position="bottom-right"
            class="shareOverlay"
            overlay-class="shareOverlayWrap"
        >
            <div class="shareBox">
                <p class="closeImg" v-show="createImgStatus !== '1'"><img :src="CloseImg"  @click="closeShareOverlay" alt="" /></p>
                <div v-if="createImgStatus === '1'" class="imgLoadTip">
                    <van-loading type="spinner" color="#E41D1D" vertical text-color="#FFFFFF">图片加载中...</van-loading>
                </div>
                <div v-else-if="createImgStatus === '3'" class="imgLoadTip">
                    <van-icon name="photo-o" size="48" />
                    <p class="imgTip">图片加载失败</p>
                </div>
                <img v-else class="posterImg" :src="base64" alt="" />
                
                <div class="downloadBox" v-show="createImgStatus === '2'">
                    <div class="downloadBtn" @click="downloadImage">
                        <img :src="DownloadImg" alt="" />
                        <span>保存到相册</span>
                    </div>
                    <p class="tip">需允许中国军号访问相册权限</p>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
import { mapState } from "vuex"
import Util from "@/utils/util"
import html2canvas from "html2canvas"
import AvatarImg from "@/assets/images/morentoux.png"
import LogoImg from "@/assets/images/collectMedal/logo.png"
import TipImg from "@/assets/images/collectMedal/tip.png"
import CloseImg from "@/assets/images/collectMedal/close.png"
import DownloadImg from "@/assets/images/collectMedal/download.png"
import OpenMusicImg from "@/assets/images/collectMedal/openMusic.png"
import CloseMusicImg from "@/assets/images/collectMedal/closeMusic.png"

let timer = null // 定时器
let TEM_SDK = null // SDK实例

// 是否为开发环境
const host = window.shareUlr.appDownUrl || 'https://api-pre.junhao.mil.cn'
const hostUrl = host.replace('api-', 'web-').replace('api.', 'web.') + '/cms/rmt9502' // 主域名
const doMain = hostUrl + '/medal/' // 3D模型地址前缀
const tenantId = Util.getIdsObj().TenantID // 租户ID
const medalId = Util.getIdsObj().medalId // 徽章ID
const isInner = Util.getIdsObj().isInner=== 'true' // 是否为内部人员
const isBack = Util.getIdsObj().isBack
export default {
    name: "CollectMedal",
    data() {
        return {
            OpenMusicImg,
            CloseMusicImg,
            AvatarImg,
            LogoImg,
            TipImg,
            CloseImg,
            DownloadImg,
            posterImg: "",
            base64: "",
            isLoading: false,
            showTip: false,
            showShare: false,
            btnName: "领取",
            isShowBtn: false,
            btnLoading: false,
            createImgStatus: '1', // 1:进行中 2:成功 3:失败
            userInfo: {},
            isPlay: false,
            isCollect: false, // 是否领取过徽章
            isInner,
            memberMedalExtend: {},
            loading:false
        }
    },
    // 计算属性
    computed: {
        ...mapState({
            medalDetail: (state) => state.collectMedal.medalDetail,
            // loading: (state) => state.collectMedal.loading,
            userIsCollect: (state) => state.collectMedal.userIsCollect,
            userCollectNum: (state) => state.collectMedal.userCollectNum
        })
    },
    created() {
        // 判断是否为ios系统
        const isIosSystem = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) || navigator.userAgent.indexOf('iPad') > -1 || navigator.userAgent.indexOf('iPhone') > -1
        // jssdk初始化
        TEM_SDK = new window.TemplateSDK({
            threeModelConf: {
                isShowClose: true, // 是否显示关闭按钮
                src:'',
                // src: doMain + (isInner? 'medal_inner.gltf' : 'medal.gltf'), // 3D模型文件地址
                // src: 'https://web-pre.junhao.mil.cn/cms/rmt9502/medal/medal.gltf', // 3D模型文件地址
                scale: 0.6, // 缩放比例
                rotation: [0, Math.PI, 0], // 旋转角度-单位弧度
                isOpenColor: true, // 是否开启颜色
                emissiveIntensity:  0.8, // 设置颜色强度
                bgColor: '#141B27' // 背景色
            }, // 3D模型文件配置
            switchConf: false, // 页面功能开关（点赞、评论等） 默认false：打开app；true：可以进行相关操作；json数据：控制单个功能
            imgGray: false, // 图片变灰，默认false，设置为true时全局图片置灰
            templateConf: {
                tenantId, // 租户ID
                siteId: window.shareUlr.siteid, // 站点ID
                iosDownUrl: window.shareUlr.appDownUrl,
                androidDownUrl: window.shareUlr.appDownUrl,
                iosPKG: window.shareUlr.iosPKG,
                androidPKG: window.shareUlr.androidPKG,
                articleType: isIosSystem ? 108 : 8, // 类型
                articleUrl: encodeURIComponent(window.location.href), // 当前页面的url
                tag: 2
            }
        })
        console.log(isIosSystem, 'isIosSystem=====');
        window.tem_jssdk = TEM_SDK
        this.getMedalDetail()
    },
    mounted() {
        // this.createAudioDom()
        // 监听页面滚动200后显示返回顶部按钮
        // window.addEventListener("scroll", this.handleScroll)
        //监听class为collectMedalBox的元素的滚动

        this.$nextTick(() => {
            const scrollBox = document.querySelector('.collectMedalBox')
            scrollBox.addEventListener('scroll', this.handleScroll)
        })
    },
    beforeDestroy() {
        window.removeEventListener("scroll", this.handleScroll)
        clearInterval(timer)
    },
    methods: {
        // 下拉刷新
        onRefresh() {
            this.isLoading = true
            this.getMedalDetail()
        },
        // 监听页面滚动200后显示底部按钮
        handleScroll() {
            //当.collectMedalBox元素滚动大于200时this.isShowBtn为true
            const scrollBox = document.querySelector('.collectMedalBox')
            if(scrollBox.scrollTop > 200 && !this.isBack) {
                this.isShowBtn = true
            } else {
                this.isShowBtn = false
            }
            //老逻辑监听的整个页面，因为要在iframe中隐藏滚动条，所以改为监听collectMedalBox
            // const scrollTop =
            //     document.documentElement.scrollTop || document.body.scrollTop
            // if (scrollTop > 200 && !isBack) {
            //     this.isShowBtn = true
            // } else {
            //     // this.isShowBtn = false
            // }
        },
        // 获取勋章详情
        getMedalDetail() {
            this.loading = true
            // 请求徽章详情数据
            this.$store.dispatch("getMedalDetail", {
                medalId,
                tenantId
            }).then((res) => {
                // 成功后再去获取用户信息和判断是否领取过徽章
                if (res.code === "0000") {
                    document.title = res.data.medalName
                    if(res.data.memberMedalExtend){
                        let memberMedalExtend = res.data.memberMedalExtend
                        this.memberMedalExtend = memberMedalExtend
                        if(memberMedalExtend.thirdImage){
                            TEM_SDK.threeModelConf.src = res.data.memberMedalExtend.thirdImage
                            TEM_SDK.setThreeModelPopup()
                        }
                        if(memberMedalExtend.backMusic){
                            this.createAudioDom()
                        }
                    }
                    this.loading = false
                    this.getUserInfo(false)
                }
                this.isLoading = false
            })
        },
        // 获取用户信息
        getUserInfo(isLogin) {
            TEM_SDK.getUserInfoAsync(isLogin, res => {
                console.log(res, "getUserInfoAsync");
                if(
                    res.returnCode === '0000' &&
                    typeof res.returnMsg === 'object' &&
                    res.returnMsg.userInfo &&
                    res.returnMsg.userInfo.userid
                ) {
                    console.log(isLogin, 'isLogin==========')
                    this.userInfo = { ...res.returnMsg.userInfo }
                    if (!isLogin) { // 非强制登录下才去判断是否领取过徽章 强制登录时需要重新点击领取按钮
                        this.getIsCollect()
                    }
                } else {
                    console.log(res.returnCode, '走到这里了~~~~~~')
                    this.$store.dispatch('initUserIsCollect')
                }
            })
        },
        // 获取用户是否领取过徽章
        getIsCollect() {
            this.$store.dispatch("getUserIsCollect", {
                memberId: this.userInfo.userid,
                medalId,
                tenantId
            })
        },
        // 预览3D模型
        viewThreeModel() {
            if(this.memberMedalExtend.thirdImage){
                TEM_SDK.openThreeModel()
            }
        },
        // 播放音乐
        playMusic() {
            const audioDom = document.getElementById("audioDom")
            if (this.isPlay) {
                audioDom.pause()
                this.isPlay = false
            } else {
                audioDom.play()
                this.isPlay = true
            }
        },
        // 点击领取
        handleCollect() {
            if (this.btnName === "已结束") {
                this.$toast("活动已结束")
                return
            }
            if(TEM_SDK.isApp) { // app内
                if (this.btnName === "已领取") {
                    this.isCollect = true
                    this.showTip = true
                } else if (this.btnName === "未开始") {
                    // 判断是否登录
                    if (this.userInfo.userid) {
                        this.$toast("活动未开始")
                    } else {
                        this.getUserInfo(true)
                    }
                } else if (this.btnName === "领取") {
                    // 判断是否登录
                    if (this.userInfo.userid) {
                        this.toCollectMedal()
                    } else {
                        console.log('去登录');
                        this.getUserInfo(true)
                    }
                }
            } else { // h5
                // this.showTip = true
                const downloadUrl = hostUrl + '/appDownload/download.html?share_channel=%E7%BA%BF%E4%B8%8A%E6%B4%BB%E5%8A%A8&channel_code=5#/'
                console.log(downloadUrl, 'downloadUrl=======')
                TEM_SDK.openApp(undefined, downloadUrl)
            }
        },
        // 领取徽章
        toCollectMedal() {
            if(this.btnLoading) return
            this.btnLoading = true
            this.$store.dispatch("toCollectMedal", {
                memberId: this.userInfo.userid,
                medalId,
                tenantId
            }).then((res) => {
                this.btnLoading = false
                if(res.code === '0000') {
                    this.isCollect = true
                    this.showTip = true
                }
            }).catch((err) => {
                this.btnLoading = false
            })
        },
        // 关闭提示/去分享
        closeOverlay(type) {
            this.showTip = false
            if (type === "share") {
                let obj = localStorage.getItem('medalUserJson')
                let isFirst = true
                if(obj) {
                    obj = JSON.parse(obj)
                    if(obj[this.userInfo.userid + '_' + medalId]) {
                        isFirst = false
                        this.base64 = obj[this.userInfo.userid + '_' + medalId]
                        this.posterImg = obj[this.userInfo.userid + '_' + medalId]
                        this.createImgStatus = '2'
                    }
                }
                isFirst && this.createPosterImg()
                this.showShare = true
            }
        },
        // 生成图片
        createPosterImg() {
            if(this.posterImg) return
            console.log('开始生成图片：' + new Date())
            const element = document.getElementById("posterImgBox")
            this.createImgStatus = '1'
            // 是否已经有音频 有的话就从body中删除 记住当前播放位置
            const audioDom = document.getElementById("audioDom")
            console.log(audioDom, 'audioDom');
            console.log(this.isCollect, 'this.isCollect');
            let currentTime = 0
            let hasAudio = false
            if(this.isCollect && audioDom) {
                hasAudio = true
                currentTime = audioDom.currentTime
                document.body.removeChild(audioDom)
            }

            html2canvas(element, {
                scale: window.devicePixelRatio, // 使用设备像素比
                useCORS: true
            }).then((canvas) => {
                // 创建音频
                hasAudio && this.createAudioDom(currentTime)
                const context = canvas.getContext('2d')
                const imageData = context.getImageData(1, 1, canvas.width - 4, canvas.height - 4) // 裁剪掉 1px 的边框
                const newCanvas = document.createElement('canvas')
                newCanvas.width = canvas.width - 4
                newCanvas.height = canvas.height - 4
                newCanvas.getContext('2d').putImageData(imageData, 0, 0)
                const img = newCanvas.toDataURL('image/png')
                if(img.indexOf('data:image/png;base64,') === -1) {
                    this.createImgStatus = '3'
                    return
                }
                console.log('生成图片完成：' + new Date())
                this.base64 = img
                this.createImgStatus = '2'
                this.getServerImg(img)
            }).catch((err) => {
                console.log(err, 'err')
                this.createImgStatus = '3'
                // 创建音频
                hasAudio && this.createAudioDom(currentTime)
            })
        },
        // 获取服务器图片
        getServerImg(src) {
            this.$store.dispatch("getServerImg", {
                base64: [src],
                tenantId
            }).then((res) => {
                if (res.state === 200) {
                    this.posterImg = res.data.returnPaths[0]
                    // 设置localStorage缓存
                    let obj = localStorage.getItem('medalUserJson')
                    let newObj = {
                        [this.userInfo.userid + '_' + medalId]: this.posterImg
                    }
                    if(obj) {
                        obj = JSON.parse(obj)
                        newObj = {
                            ...obj,
                            [this.userInfo.userid + '_' + medalId]: this.posterImg
                        }
                    }
                    localStorage.setItem('medalUserJson', JSON.stringify(newObj))
                } else {
                    this.createImgStatus = '3'
                }
            })
        },
        // 关闭分享弹层
        closeShareOverlay() {
            this.showShare = false
        },
        // 下载图片
        downloadImage() {
            console.log(this.posterImg, '保存的图片地址====')
            TEM_SDK.saveImageToPhotosAlbum({
                src: this.posterImg,
                base64: this.base64,
                name: this.medalDetail.medalName,
            })
        },
        // 处理时间格式  兼容ios
        handleTime(time) {
            return time.replace(/-/g, '/')
        },
        // 动态创建audio标签
        createAudioDom(time = 0) {
            //判断当前页面是否有音频标签，有的话就不再创建
            if(document.getElementById("audioDom")) return
            console.log(time, 'time');
            // const oldAudioDom = document.getElementById("audioDom")
            let currentTime = 0
            // if(oldAudioDom) {
            //     currentTime = oldAudioDom.currentTime
            //     document.body.removeChild(audioDom)
            // }
            const audioDom = document.createElement('audio')
            audioDom.id = 'audioDom'
            audioDom.src = this.memberMedalExtend.backMusic
            audioDom.loop = true
            audioDom.autoplay = true
            // 如果有 time  则跳到对应时间上
            audioDom.currentTime = time || currentTime
            document.body.appendChild(audioDom)

            // 监听音频是否播放
            audioDom.addEventListener('play', () => {
                this.isPlay = true
            })

            audioDom.addEventListener('pause', () => {
                this.isPlay = false
            })
        }
    },
    watch: {
        userIsCollect(val) {
            console.log(val, "userIsCollect")
            console.log(this.showTip, 'this.showTip');
            if(timer) clearInterval(timer)
            if (val) {
                this.btnName = "已领取"
                // if(!this.posterImg) {
                //     setTimeout(() => {
                //         this.createPosterImg()
                //     }, 1000)
                // }
            } else {
                // 获取当前时间和medalDetail中的开始时间作对比
                if (this.medalDetail.startTime) {
                    const nowTime = new Date().getTime()
                    const startTime = new Date(TEM_SDK.isIos ? this.handleTime(this.medalDetail.startTime) : this.medalDetail.startTime).getTime()
                    const endTime = new Date(TEM_SDK.isIos ? this.handleTime(this.medalDetail.endTime) : this.medalDetail.endTime).getTime()
                    // console.log(startTime, endTime, '时间');
                    if (nowTime >= startTime && nowTime < endTime) {
                        // 进行中
                        this.btnName = "领取"
                    } else if (nowTime >= endTime) {
                        // 已结束
                        this.btnName = "已结束"
                    } else {
                        this.btnName = "未开始"
                        // 设置定时器到开始时间后更新按钮状态
                        timer = setInterval(() => {
                            const nowTime1 = new Date().getTime()
                            if (nowTime1 >= startTime) {
                                this.btnName = "领取"
                                clearInterval(timer)
                            }
                        }, 1000)
                    }
                } else {
                    this.btnName = "领取"
                }
            }            
        }
    }
}
</script>

<style lang="less" scoped>
.collectMedalBox {
    height: 100vh;
    background-color: #141b27;
    color: #ffffff;
    font-family: PingFang SC, PingFang SC;
    font-size: 1.5rem;
    // 设置字间距
    letter-spacing: 0.1rem;
    overflow-y: auto;
    scrollbar-width: none;
    p {
        margin: 0;
        padding: 0;
    }

    .num {
        height: 2rem;
        font-size: 1.4rem;
        font-weight: 500;
        line-height: 2rem;
        margin-top: 0.5rem;
        color: #CA9E08;
    }

    .pd_15 {
        padding: 0 1.5rem;
    }

    .loadIcon {
        text-align: center;
        line-height: 100vh;
    }

    .header {
        width: 100%;
        height: 43.8rem;
        background: url("../../assets/images/collectMedal/headerBg.png") no-repeat
        center;
        background-size: cover;
        position: relative;
        // display: flex;
        // align-items: center;
        // justify-content: center;

        .medalImg {
            position: absolute;
            bottom: 8.5rem;
            left: 50%;
            transform: translateX(-50%);
            width: 21.5rem;
        }

        .playImg {
            position: absolute;
            top: 2rem;
            right: 2rem;
            width: 2.4rem;
            height: 2.4rem;
        }
    }

    .title {
        margin-top: 3.2rem;
        text-align: center;

        img {
            width: 26.2rem;
        }
    }

    .logoBox {
        margin: 2.4rem 0 2rem;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .left {
            display: flex;
            align-items: center;

            img {
                width: 3.6rem;
                margin-right: 0.8rem;
            }
        }
    }

    .descBox {
        padding-bottom: 6.7rem;

        .desc {
            display: flex;
            align-items: center;
            justify-content: center;

            .line {
                display: inline-block;
                width: 3rem;
                height: 0.2rem;
            }

            .bg1 {
                background: linear-gradient(90deg, rgba(0, 0, 0, 0) 0%, #ffffff 100%);
            }

            .bg2 {
                background: linear-gradient(90deg, #ffffff 0%, rgba(0, 0, 0, 0) 100%);
            }

            .name {
                font-size: 2rem;
                margin: 0 1.6rem;
            }
        }

        .descImg {
            margin-top: 1.2rem;

            img {
                max-width: 100%;
            }
        }
    }

    .btnBox {
        position: fixed;
        bottom: -5rem;
        width: 100%;
        max-width: 640px;
        transition: all 0.5s ease-in-out;

        .van-button {
            font-size: 17px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            color: #ffffff;
            line-height: 2.4rem;
            letter-spacing: 0.1rem;
            height: 4rem;
            box-shadow: 0 0 0.6rem 0 rgba(255, 255, 255, 0.3);
        }

        .van-button--disabled {
            opacity: 1;
        }
    }

    .btnBox.show {
        bottom: 1.5rem;
    }

    .tipWrapper {
        display: flex;
        align-items: center;
        justify-content: center;

        .box {
            width: 31.5rem;
            height: 33.4rem;
            background: #1b2537;
            border-radius: 2px 2px 2px 2px;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding-top: 3rem;

            .imgBox {
                width: 13.6rem;
                text-align: center;

                img {
                    width: 100%;
                    height: 13.6rem;
                    object-fit: cover;
                }
            }

            .tip {
                width: 21.7rem;
                height: 4.8rem;
                font-size: 1.7rem;
                line-height: 2.4rem;
                text-align: center;
                margin-top: 1.6rem;
            }

            .footer {
                margin-top: 2.5rem;
                height: 4.9rem;
                width: 100%;
                border-top: 1px solid #26334A;
                display: flex;
                justify-content: space-between;
                align-items: center;

                .closeBtn {
                    width: 50%;
                    height: 100%;
                    line-height: 4.9rem;
                    text-align: center;
                    font-size: 1.8rem;
                    font-weight: 400;
                    color: #B6B6B6;
                }

                .leftBtn {
                    border-right: 1px solid #26334A;
                }
            }
        }
    }

    .posterImgWrap {
        position: absolute;
        top: -9999px;
        background-color: #1B2537;
        padding: 0.5rem;

        .posterImgBox {
            width: 31.8rem;
            background: #1B2537;
            padding-bottom: 1.6rem;
            // border-radius: 0.2rem;
    
            .userBox {
                background: url("../../assets/images/collectMedal/shareBg.png") no-repeat center;
                background-size: cover;
                width: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                padding-top: 2.4rem;
    
                .userImg {
                    width: 4.1rem;
                    height: 4.1rem;
                    border-radius: 3rem;
                    background: #FFFFFF;
    
                    img {
                        width: 100%;
                        height: 100%;
                        border-radius: 3rem;
                        object-fit: cover;
                        // background: #f8f8f8;
                    }
                }
    
                .userName {
                    font-size: 1.4rem;
                    font-weight: 500;
                    line-height: 2rem;
                    height: 6rem;
                    text-align: center;
                    margin-top: 0.8rem;
                }
    
                .medalImg {
                    width: 11rem;
                    height: 11rem;
    
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }
    
                .num {
                    margin-top: 0.8rem;
                }
            }
    
            .tipBox {
                margin-top: 1.6rem;
                text-align: center;
    
                .tip {
                    font-size: 1.7rem;
                    line-height: 2.4rem;
                    font-weight: 400;
                }
            }
    
            .logoWrap {
                margin-top: 2.4rem;
                display: flex;
                justify-content: space-between;
                align-items: center;
                border-top: 1px solid #26334A;
                padding-top: 1.2rem;
    
                .left {
                    display: flex;
                    flex-direction: column;
    
                    .top {
                        display: flex;
                        align-items: center;
    
                        .logoImg {
                            width: 2.4rem;
                            height: 2.4rem;
                        }
    
                        .tipImg {
                            width: 7.2rem;
                            height: 1rem;
                            margin-left: 0.4rem;
                        }
                    }
    
                    .bottom {
                        margin-top: 0.4rem;
                        font-size: 1rem;
                        font-weight: 400;
                        color: #999999;
                    }
                }
    
                .right {
                    width: 5rem;
                    height: 5rem;
    
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }
            }
        }
    }

    /deep/ .shareOverlayWrap {
        background-color: rgba(0, 0, 0, 0.8);
    }

    .shareOverlay {
        background: unset;
        width: 31.8rem;
        border-radius: 0.2rem;
        top: 46%;

        .closeImg {
            text-align: right;
            margin-bottom: 0.6rem;

            img {
                width: 2.4rem;
                height: 2.4rem;
            }
        }

        .imgLoadTip {
            height: 43.875rem;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;

            .van-loading__text {
                color: #FFFFFF;
            }

            .imgTip {
                margin-top: 0.6rem;
            }
        }

        .posterImg {
            width: 100%;
            border-radius: 0.2rem;
        }

        .downloadBox {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            font-size: 1.6rem;
            margin-top: 1.6rem;

            .downloadBtn {
                display: flex;
                align-items: center;
                justify-content: center;
                text-align: center;
                color: #FFFFFF;
    
                img {
                    width: 1.8rem;
                    height: 1.8rem;
                }
    
                span {
                    margin-left: 0.3rem;
                    margin-top: -0.2rem;
                }
            }

            .tip {
                font-size: 1.2rem;
                color: rgba(255, 255, 255, 0.5);
                margin-top: 0.5rem;
            }
        }
    }
}

.collectMedalBox::-webkit-scrollbar {
    display: none; 
  }
</style>